<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    title="" width="50%" @closed="$emit('update:visible', false)">
    <el-form
      align="left"
      size="mini"
      ref="topForm"
      :model="formQuery"
      :inline="true"
      class="flex flex-justify-between"
    >
      <el-form-item label="">{{ version }}</el-form-item>
      <div>
        <el-form-item label="用户名" prop="userName">
          <el-input
            placeholder="请输入用户名"
            v-model="formQuery.userName"
            @change="queryTableData(1)"
          />
        </el-form-item>
        <el-form-item label="用户ID" prop="userId">
          <el-input
            placeholder="请输入用户ID"
            v-model="formQuery.userId"
            @change="queryTableData(1)"
          />
        </el-form-item>
      </div>
    </el-form>
    <div class="event-table flex-1 flex flex-column padding-top-20">
      <el-table
        max-height="400px"
        :data="tableData"
        size="mini"
        stripe
      >
        <el-table-column
          v-for="(item, index) in columnsList"
          :width="item.width"
          :min-width="item.minWidth"
          :label="item.label"
          :prop="item.prop"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
        />
      </el-table>
      <el-row class="padding-20">
        <el-col align="right">
          <el-pagination
            class="analyze-users-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableQuery.pageNum"
            :page-sizes="[20, 50, 100, 200, 300, 400]"
            :page-size="tableQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableQuery.total"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)" size="small">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  queryVersionUserList,
} from '@/api/analyze';

export default {
  props: {
    visible: Boolean,
    version: String,
  },
  data() {
    return {
      formQuery: {
        userName: '',
        userId: '',
      },
      tableQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      tableData: [],
      columnsList: [
        {
          label: '用户名',
          prop: 'userName',
        },
        {
          label: '用户ID',
          prop: 'userId',
        },
      ],
    };
  },
  methods: {
    async queryTableData(currentPageNum) {
      console.log(currentPageNum);
      if (currentPageNum) {
        this.tableQuery.pageNum = currentPageNum;
      }
      try {
        this.queryLoading = true;

        // eslint-disable-next-line object-curly-newline
        const { version, tableQuery, formQuery } = this;
        const { pageNum, pageSize } = tableQuery;
        const {
          userName,
          userId,
        } = formQuery;

        const params = {
          pageNum,
          pageSize,
          version,
          userName,
          userId,
        };

        const {
          data: { list, total },
        } = await queryVersionUserList(params);
        this.tableQuery.total = total;
        this.tableData.splice(0, this.tableData.length, ...list);
      } finally {
        this.queryLoading = false;
      }
    },
    handleSizeChange(size) {
      this.tableQuery.pageSize = size;
      this.tableQuery.pageNum = 1;
      this.queryTableData();
    },
    handleCurrentChange(num) {
      this.tableQuery.pageNum = num;
      this.queryTableData();
    },
  },
  watch: {
    visible(value) {
      if (value) {
        // 请求数据
        this.queryTableData(1);
      }
    },
  },
  mounted() {},
};
</script>
